import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Tooltip,
  Collapse,
} 
from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PendingIcon from '@mui/icons-material/Schedule';
import DoneIcon from '@mui/icons-material/Done';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

interface Props {
  // collapsed: boolean;
  // selectedPage: string;
  // onSelect: (key: string) => void;

  collapsed: boolean;
  selectedPage: string;
  onSelect: (key: string) => void;
  mobileOpen: boolean;
  setMobileOpen: (val: boolean) => void;
  isMobile: boolean;
}

const drawerWidth = 240;
const collapsedWidth = 64;

const Sidebar: React.FC<Props> = ({ collapsed, selectedPage, mobileOpen, setMobileOpen, isMobile, onSelect }) => {
 
  const [ordersOpen, setOrdersOpen] = useState(true);





  const handleParentClick = () => setOrdersOpen((o) => !o);

  return (
    <Drawer 
    // className='admin-drawer'
    //   variant="permanent"
    //   sx={{
       
    //     width: collapsed ? collapsedWidth : drawerWidth,
    //     flexShrink: 0,
    //     '& .MuiDrawer-paper': {
    //       width: collapsed ? collapsedWidth : drawerWidth,
    //       overflowX: 'hidden',
    //       transition: 'width 0.3s',
    //     },
    //   }}
  className="admin-drawer"
  variant={isMobile ? "temporary" : "permanent"}
  open={isMobile ? mobileOpen : true}
  onClose={() => setMobileOpen(false)}
  sx={{
    width: collapsed ? collapsedWidth : drawerWidth,
    flexShrink: 0,
    display: {
      xs: 'block',
      sm: 'block',
    },
    '& .MuiDrawer-paper': {
      width: collapsed ? collapsedWidth : drawerWidth,
      boxSizing: 'border-box',
      overflowX: 'hidden',
      transition: 'width 0.3s',
    },
  }}
  ModalProps={{
    keepMounted: true, // Better performance on mobile
  }}
    >
      <Toolbar />

      <List disablePadding  className='admin-sidebar'>
      
        {/* <Tooltip title={collapsed ? 'Dashboard' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'dashboard'}
            onClick={() => onSelect('dashboard')}
          >
            <ListItemIcon><DashboardIcon /></ListItemIcon>
            {!collapsed && <ListItemText primary="Dashboard" />}
          </ListItem>
        </Tooltip> */}

          <Tooltip title={collapsed ? 'User Requests' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'userRequest'}
            onClick={() => onSelect('userRequest')}
          >

            <ListItemIcon>
              <i>
              <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
 
              </i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="User Requests" />}
          </ListItem>
        </Tooltip>

         <Tooltip title={collapsed ? 'Model Requests' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'requests'}
            onClick={() => onSelect('requests')}
          >
            <ListItemIcon>
              <i><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><circle cx="5" cy="6" r="3"></circle><path d="M5 9v12"></path><circle cx="19" cy="18" r="3"></circle><path d="m15 9-3-3 3-3"></path><path d="M12 6h5a2 2 0 0 1 2 2v7"></path></svg></i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Model Requests" />}
          </ListItem>


          

              {/* <ListItem
            button
            selected={selectedPage === 'admin'}
            onClick={() => onSelect('admin')}
          >
            <ListItemIcon><DashboardIcon /></ListItemIcon>
            {!collapsed && <ListItemText primary="admin" />}
          </ListItem> */}

        </Tooltip>
       
        <Tooltip title={collapsed ? 'Upload Documents' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'upload'}
            onClick={() => onSelect('upload')}
          >
            <ListItemIcon>
              <i>
                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5-5 5z"></path></svg>
              </i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Upload Documents" />}
          </ListItem>
        </Tooltip>

        <Tooltip title={collapsed ? 'Company Onboarding' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'companyOnboarding'}
            onClick={() => onSelect('companyOnboarding')}
          >
            <ListItemIcon>
              <i>
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M3 21h18"></path><path d="M5 21V7l8-4v18"></path><path d="M19 21V11l-6-4"></path><path d="M9 9h1"></path><path d="M9 13h1"></path><path d="M9 17h1"></path><path d="M15 13h1"></path><path d="M15 17h1"></path></svg>
              </i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Company Onboarding" />}
          </ListItem>
        </Tooltip>

         <Tooltip title={collapsed ? 'User Management' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'userManagement'}
            onClick={() => onSelect('userManagement')}
          >
            <ListItemIcon>
              <i>
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M2 21a8 8 0 0 1 10.434-7.62"></path><circle cx="10" cy="8" r="5"></circle><circle cx="18" cy="18" r="3"></circle><path d="m19.5 14.3-.4.9"></path><path d="m16.9 20.8-.4.9"></path><path d="m21.7 19.5-.9-.4"></path><path d="m15.2 16.9-.9-.4"></path><path d="m21.7 16.5-.9.4"></path><path d="m15.2 19.1-.9.4"></path><path d="m19.5 21.7-.4-.9"></path><path d="m16.9 15.2-.4-.9"></path></svg>
                
              </i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="User Management" />}
          </ListItem>
        </Tooltip>

        <Tooltip title={collapsed ? 'Model Management' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'modelManagement'}
            onClick={() => onSelect('modelManagement')}
          >
            <ListItemIcon>
              <i>
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M8 8h8v8h-8z"></path><path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"></path><path d="M16 16l3.3 3.3"></path><path d="M16 8l3.3 -3.3"></path><path d="M8 8l-3.3 -3.3"></path><path d="M8 16l-3.3 3.3"></path></svg>                
              </i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Model Management" />}
          </ListItem>
        </Tooltip>

        <Tooltip title={collapsed ? 'Screen Management' : ''} placement="right">
          <ListItem
            button
            selected={selectedPage === 'screenManagement'}
            onClick={() => onSelect('screenManagement')}
          >
            <ListItemIcon>
              <i>
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="4" width="18" height="14" rx="2"></rect><path d="M8 21h8"></path><path d="M12 17v4"></path><path d="m8 9 2.5 2.5L16 6"></path></svg>
              </i>
            </ListItemIcon>
            {!collapsed && <ListItemText primary="Screen Management" />}
          </ListItem>
        </Tooltip>

    


        {/* <ListItem
          button
          onClick={handleParentClick}
          selected={selectedPage === 'orders' || selectedPage.startsWith('orders/')}
        >
          <ListItemIcon><ShoppingCartIcon /></ListItemIcon>
          {!collapsed && <ListItemText primary="Orders" />}
         {!collapsed && (ordersOpen ? <ExpandMore /> : <ExpandLess />)}

        </ListItem> */}

       
        {/* <Collapse in={ordersOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
           
            <ListItem
              button
              sx={{ pl: collapsed ? 2 : 4 }}
              selected={selectedPage === 'orders/pending'}
              onClick={() => onSelect('orders/pending')}
            >
              <ListItemIcon><PendingIcon fontSize="small" /></ListItemIcon>
              {!collapsed && <ListItemText primary="Pending Orders" />}
            </ListItem>
            
            <ListItem
              button
              sx={{ pl: collapsed ? 2 : 4 }}
              selected={selectedPage === 'orders/completed'}
              onClick={() => onSelect('orders/completed')}
            >
              <ListItemIcon><DoneIcon fontSize="small" /></ListItemIcon>
              {!collapsed && <ListItemText primary="Completed Orders" />}
            </ListItem>
          </List>
        </Collapse> */}
      </List>

    </Drawer>
  );
};

export default Sidebar;
